export default [{
        path: '/home',
        name: 'home',
        component: () => import( /* webpackChunkName: "home" */ './Home'),
        children: [{
            name: 'home/class-schedules',
            path: '/home/class-schedules',
            components: {
                navigation: () => import( /* webpackChunkName: "classschedules" */ './class-schedule/ClassSchedule')
            }
        }, {
            name: 'home/registered-classes',
            path: '/home/registered-classes',
            components: {
                navigation: () => import( /* webpackChunkName: "classes" */ './registered-classes/RegisteredClasses')
            }
        }, {
            name: 'home/general-config',
            path: '/home/general-config',
            components: {
                navigation: () => import( /* webpackChunkName: "config" */ './general-config/GeneralConfig')
            }
        }]

    },
    {
        path: '/member',
        name: 'member',
        component: () => import( /* webpackChunkName: "home" */ './HomeMember'),
        children: [{
            name: 'member/class-schedules',
            path: '/member/class-schedules',
            components: {
                navigation: () => import( /* webpackChunkName: "classschedules" */ './class-schedule/ClassSchedule')
            }
        }]
        //meta: { requiresAuth: true}
    },
]